module.exports = __webpack_public_path__ + "img/SD-fig6.51a023fc.svg";